import { useEffect, useState } from "react";
import { fetchProfileImageUrl } from "../services/HelperService";

export function useProfileImage(uid: string, index: number, defaultUrl?: string) {

    const [imgUrl, setImgUrl] = useState(defaultUrl)

    useEffect(() => {

        async function action() {
            const url = await fetchProfileImageUrl(uid, index)
            if(index == 0 && url == undefined)
             return
            setImgUrl(url)
        }

        action()

    }, [])

    return { imgUrl }
}